export default [{
        url: '/customdashboard',
        name: 'Dashboard Kendall',
        icon: 'dashboard'
    },
    {
        url: '/customdashboardRojana',
        name: 'Dashboard Endeavor',
        icon: 'dashboard'
    },
    {
        url: '/customdashboardBangplee',
        name: 'Dashboard Unicorn',
        icon: 'dashboard'
    },
]